import Vue from 'vue';
import SelectList from '../elements/selectlist';

export default Vue.component('quick-search', {
    template:`
        <fragment>
            <form id="formId" autocomplete="off" v-on:submit="quicksearch" class="ml-2">            
                <div class="input-group">
                    <input ref="keyword" class="form-control form-control-sm form-control-alt" v-model="queryParameters.keyword" name="keyword" :placeholder="placeholder" />
                    <div class="input-group-append">
                        <button class="input-group-text bg-body border-0" type="submit" form="formId">
                            <i class="fa fa-fw fa-search"></i>
                        </button>
                    </div>
                </div>
            </form>
            <selectlist :value.sync="queryParameters.pageSize" :settings="paginationSettings.pageSize" @input="pageSizeUpdated" classes="form-control-sm form-control-alt ml-2" />
        </fragment>
    `,
    inject: [
        'performQuickSearch'
    ],
    props:{
        queryParameters: Object,
        resources: Object,
        loadingRows: Boolean,
        paginationSettings: Object,
        placeholder: { type: String, default: 'Search' }
    },
    computed:{
        formId(){
            return `quicksearch-${this._uid}`;
        }
    },
    methods:{
        quicksearch(event){
            event.preventDefault();
            this.performQuickSearch();
        },
        pageSizeUpdated(pageSize){
            this.queryParameters.pageSize = pageSize;
            this.performQuickSearch();
        }
    },
    components:{
        'selectlist': SelectList
    },
    mounted(){
        this.$refs.keyword.focus();
    }
});